import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const TriangleUp = ({
  width = 13,
  height = 9,
  className,
  filled,
  color,
  decorative = false,
  ariaLabel = "Up triangle",
}: IconProps) => {
  const classes = createColorClasses({ color });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={filled ? "currentColor" : "none"}
      viewBox="0 0 13 9"
      className={clsx(className, classes)}
      aria-hidden={decorative ? "true" : "false"}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        d="M1.83747 9.25L7 0.946934L12.1625 9.25H1.83747Z"
        stroke="currentColor"
      />
    </svg>
  );
};

